export default "__VITE_ASSET__YNy4vz3$__"